import { toast } from "react-toastify";

/**
 * Show success toast. Uses app default container.
 * @param {string} msg
 * @param {object} [opts] - e.g. { autoClose: 4000 }
 */
export function toastSuccess(msg, opts = {}) {
  toast.success(msg, opts);
}

/**
 * Show error toast. Extracts message from error object or uses string.
 * Order: err.response?.data?.message, err.response?.data?.error, err.message, fallback.
 * @param {Error|string} errOrMsg
 * @param {object} [opts] - e.g. { autoClose: 6000 }
 */
export function toastError(errOrMsg, opts = {}) {
  const msg =
    typeof errOrMsg === "string"
      ? errOrMsg
      : errOrMsg?.response?.data?.message ||
        errOrMsg?.response?.data?.error ||
        errOrMsg?.message ||
        "Something went wrong";
  toast.error(msg, opts);
}

/**
 * Show info toast. Uses app default container.
 * @param {string} msg
 * @param {object} [opts] - e.g. { autoClose: 4000 }
 */
export function toastInfo(msg, opts = {}) {
  toast.info(msg, opts);
}
